<app-button
  variant="danger"
  [size]="size"
  [startIcon]="startIcon"
  [disabled]="disabled"
  [classes]="classes"
  [dataTestid]="dataTestid"
  (click)="onClick($event)"
>
  {{ labelKey | translate }}
</app-button>
